export const navBarHeadingLinkMap = {
  Articles: 'articlesLinkText',
  Quickstarts: 'quickstartsLinkText',
  'Auth0 APIs': 'auth0ApisLinkText',
  SDKs: 'sdksLinkText',
  'Events Catalog': 'eventCatalogLinkText'
};
